import { memo } from 'react';
import { AppShell } from '@nimbus-ds/patterns';
import { useTopAdBar } from 'App/components/TopAdBar/useTopAdBar';
import useTopBar from 'App/components/Topbar/useTopBar';
import { AgentChatView } from './components';

function AgentChat(): JSX.Element | null {
  const { height: heightTopAdBar } = useTopAdBar();
  const { height: heightTopBar } = useTopBar();

  const offsetTop = heightTopAdBar + heightTopBar;

  return (
    <AppShell.Chat
      borderLeftWidth="1"
      borderStyle="solid"
      borderColor="neutral-surfaceHighlight"
      maxWidth="378px"
      top={`${offsetTop}px`}
      height={`calc(100vh - ${offsetTop}px)`}
      margin="none"
      zIndex="100"
    >
      <AgentChatView />
    </AppShell.Chat>
  );
}

export default memo(AgentChat);
